<template>
<div>
    <BasePage v-bind="config" :list="filterList" v-on="listeners"></BasePage>
</div>
    
</template>

<script>
import BasePage from './BasePage.vue'
import {sspApi} from '@/api';
import _ from 'lodash'
import exportUtils from '@/components/util/export-utils.js'

export default {
    components: {
        BasePage
    },
    data: function () {
        return {
            queryCondition:{
                'adzoneIdOrName': "",
                'mediaIdOrName':"",
                'adResourceType':"",
                'status':""
            },
            list: [],
            listeners: {
                input: this.onInput,
                operation: this.doOperation,
                action: this.doAction,
            },
            config:{
                searchConfigs: [
                    [
                    {name:'adzoneIdOrName', label:'广告位名称或ID: ',ctx:'inputText', width: '320px'},
                    {name:'mediaIdOrName', label:'媒体名称或ID: ',ctx:'inputText', width: '320px'},
                    {name:'adResourceType', label:'广告类型: ',ctx:'inputSelect',
                        options: [
                            {id: 1, name: '信息流'},
                            {id: 2, name: '开屏'},
                            {id: 4, name: 'banner'},
                            {id: 5, name: '激励视频'},
                            {id: 6, name: '插屏'},
                        ]
                    },
                    {name:'status', label:'状态: ',ctx:'inputSelect',
                        options: [
                            {id: "运行中", name: '运行中'},
                            {id: "关闭", name: '关闭'},
                        ]
                    }
                    ]
                ],
                tableConfigs: [
                    {prop:'adzoneId', label:'广告位ID', sortable:true},
                    {prop:'adzoneName', label:'广告位名称'},
                    {prop:'mediaId', label:'所属媒体ID', sortable:true},
                    {prop:'mediaName', label:'所属媒体名称'},
                    {prop:'adForm', label:'素材方向'},
                    {prop:'createTime', label:'创建时间', sortable:true},
                    {prop:'status', label:'状态'},
                    {prop:'operation',label:'操作','min-width': 150}
                ],
                actions: [],
                showAction: true
            },
        }
    },
    created: function() {
        sspApi.listAdzone().then((response) => {
            this.list = response
        }).catch(this.$rejectAjaxError());
    },
    computed: {
        filterList: function () {
            let adzoneIdOrName = this.queryCondition.adzoneIdOrName
            let mediaIdOrName = this.queryCondition.mediaIdOrName
            let adResourceType = this.queryCondition.adResourceType
            let status = this.queryCondition.status

            return _.filter(this.list, (it) => {
                return ((it.adzoneId + "").includes(adzoneIdOrName) || (it.adzoneName + "").includes(adzoneIdOrName))
                 && ((it.mediaId + "").includes(mediaIdOrName) || (it.mediaName + "").includes(mediaIdOrName))
                 && (adResourceType === "" || it.adResourceType === adResourceType)
                 && (status === "" || it.status === status)

            })
        }
    },
    methods: {
        onInput: function (val) {
            _.assign(this.queryCondition, val);
        },
        doAction: function (name) {
            if (name === 'create') {
                this.$router.push({name: 'adzoneNew'})
            }
            if (name === 'export') {
                this.doExport()
            }
        },
        doExport: function () {
            exportUtils.export(this.filterList, this.config.tableConfigs)
        },
        doOperation: function (op) {
            let adzoneId = op.item.adzoneId
            if (op.name === 'edit') {
                //to edit page
                this.$router.push({name: 'adzoneEdit', params: {adzoneId}})
            }
            if (op.name === 'switch') {
                sspApi.switchAdzone({
                    params: {
                        adzoneId: op.item.adzoneId
                }
                }).then().catch(this.$rejectAjaxError());
                this.$notify.info({ title: '操作成功', message: '页面将自动刷新' })
                location.reload()
            }
        }
    }
}
</script>